import React, { useState, useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import useScrollReveal from "../../hooks/useScrollReveal";

const PHOTOS = Array.from({ length: 11 }, (_, i) => `/media/photos/cer${i + 1}.jpeg`);

export default function PrestationSerment8e() {
  useScrollReveal();
  const [lightbox, setLightbox] = useState({ open: false, index: 0 });
  const [copied, setCopied] = useState(false);

  const openLightbox = (idx) => setLightbox({ open: true, index: idx });
  const closeLightbox = () => setLightbox({ open: false, index: 0 });
  const prevPhoto = useCallback(() => setLightbox((s) => ({ ...s, index: (s.index - 1 + PHOTOS.length) % PHOTOS.length })), []);
  const nextPhoto = useCallback(() => setLightbox((s) => ({ ...s, index: (s.index + 1) % PHOTOS.length })), []);

  useEffect(() => {
    if (!lightbox.open) return;
    const handler = (e) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") prevPhoto();
      if (e.key === "ArrowRight") nextPhoto();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [lightbox.open, prevPhoto, nextPhoto]);

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareUrl = encodeURIComponent(window.location.href);

  return (
    <main className="ema-page">
      {/* Hero */}
      <header className="ema-communique-hero">
        <div className="ema-container">
          <div className="ema-communique-hero-inner">
            <span className="ema-badge-press">COMMUNIQUÉ DE PRESSE</span>
            <h1 className="ema-communique-title">
              8<sup>e</sup> promotion de l'école de la Magistrature (EMA) : 49 élèves magistrats, dont 13 femmes, ont serment
            </h1>
            <div className="ema-communique-meta">
              <span>23 juin 2026</span>
              <span>Pétion-Ville</span>
              <span>Conseil Supérieur du Pouvoir Judiciaire</span>
              <span>communiqué officiel</span>
            </div>
            <div className="ema-communique-emitter">
              <img src="/partenaires/cspj-logo.jpg" alt="Logo CSPJ" className="ema-cspj-logo" />
              <span>Conseil Supérieur du Pouvoir Judiciaire</span>
            </div>
          </div>
        </div>
      </header>

      {/* Cover photo */}
      <section className="ema-container" style={{ marginTop: '-60px', position: 'relative', zIndex: 2 }}>
        <div className="ema-communique-cover ema-reveal">
          <img src="/media/photos/cer1.jpeg" alt="Cérémonie de prestation de serment - 8e promotion EMA" />
        </div>
      </section>

      {/* Body */}
      <section className="ema-page-body">
        <div className="ema-container">
          <div className="ema-communique-layout">
            {/* Main content */}
            <article className="ema-communique-main ema-reveal">
              <div className="ema-communique-content">
                <p>
                  Les Élèves-Magistrats de la 8ᵉ promotion de l'École de la Magistrature (EMA) ont prêté serment le vendredi 26 juin 2026 à la salle Rock Cadet, en présence du Doyen du Tribunal de Première Instance (TPI) de Port-au-Prince, Me Bernard Saint-Vil, et du Substitut du Commissaire du Gouvernement près le Parquet du Tribunal de Première Instance de Port-au-Prince, Me Fénélon Élysée.
                </p>
                <p>
                  Cette prestation de serment marque également le début de leur stage pratique d'une durée de six (6) mois au sein des différentes juridictions du pays.
  La 8ᵉ promotion est composée de quarante-neuf (49) futurs magistrats, dont treize (13) femmes, qui viendront contribuer au renforcement de l'efficacité du système judiciaire haïtien.
                </p>
               
              </div>

              {/* Encadr\u00e9 important */}
              <div className="ema-communique-infobox ema-reveal">
                <h3>Informations importantes</h3>
                <ul>
                  <li><span></span> Vendredi 26 juin 2026</li>
                  <li><span></span> 10 h 00</li>
                  <li><span></span> Salle Rock Cadet</li>
                  <li><span></span> 49 élèves magistrats</li>
                  <li><span></span> 13 femmes</li>
                  <li><span></span> Prestation de serment officielle</li>
                </ul>
              </div>

              {/* Gallery */}
              <div className="ema-communique-gallery ema-reveal">
                <div className="ema-communique-gallery-header">
                  <h3>Galerie photo</h3>
                  <span className="ema-photo-count">{PHOTOS.length} photos</span>
                </div>
                <div className="ema-communique-gallery-grid">
                  {PHOTOS.map((src, idx) => (
                    <div
                      key={idx}
                      className="ema-gallery-thumb"
                      onClick={() => openLightbox(idx)}
                    >
                      <img src={src} alt={`C\u00e9r\u00e9monie 8e promotion - photo ${idx + 1}`} />
                      <div className="ema-gallery-thumb-overlay">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>
                        </svg>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Signature */}
              <div className="ema-communique-signature ema-reveal">
                <hr />
                <div className="ema-communique-signature-inner">
                  <img src="/partenaires/cspj-logo.jpg" alt="CSPJ" className="ema-cspj-logo-sm" />
                  <div>
                    <strong>Unité de Communication</strong>
                    <span>Conseil Supérieur du Pouvoir Judiciaire</span>
                  </div>
                </div>
              </div>

              {/* Download + Share */}
              <div className="ema-communique-actions ema-reveal">
                <a
                  href="/documents/communique-prestation-serment-8e.pdf"
                  target="_blank"
                  rel="noreferrer"
                  className="ema-btn-download"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M12 18v-6"/><path d="M9 15l3 3 3-3"/>
                  </svg>
                  Télécharger le communiqué officiel (PDF)
                </a>

                <div className="ema-communique-share">
                  <a href={`https://www.facebook.com/share/p/1CgxPmhpeA/?mibextid=wwXIfr${shareUrl}`} target="_blank" rel="noreferrer" className="ema-share-btn ema-share-fb">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                    Facebook
                  </a>
                  <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`} target="_blank" rel="noreferrer" className="ema-share-btn ema-share-li">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                    LinkedIn
                  </a>
                  <button onClick={copyLink} className="ema-share-btn ema-share-copy">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                    </svg>
                    {copied ? "Copi\u00e9 !" : "Copier le lien"}
                  </button>
                </div>
              </div>
            </article>

            {/* Sidebar */}
            <aside className="ema-communique-sidebar ema-reveal">
              <div className="ema-sidebar-card">
                <h4>Vous pourriez également aimer</h4>
                <ul className="ema-related-list">
                  <li>
                    <Link to="/announcements">Journée internationale des femmes juges</Link>
                    <span>8 mars 2026</span>
                  </li>
                  <li>
                    <Link to="/announcements">Reprise des activités de formation</Link>
                    <span>13 avril 2026</span>
                  </li>
                  <li>
                    <Link to="/announcements">Formation probatoire des juges de paix</Link>
                    <span>10 mars 2026</span>
                  </li>
                  <li>
                    <Link to="/announcements">Calendrier de la 8<sup>e</sup> promotion</Link>
                    <span>Janvier 2026</span>
                  </li>
                </ul>
              </div>

              <div className="ema-sidebar-card">
                <h4>Accès rapide</h4>
                <div className="ema-sidebar-links">
                  <Link to="/mediatheque/photos" className="ema-sidebar-link">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                    Médiathèque photos
                  </Link>
                  <Link to="/announcements" className="ema-sidebar-link">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                    Toutes les actualités
                  </Link>
                  <Link to="/ecole/chiffres" className="ema-sidebar-link">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
                    Chiffres clés
                  </Link>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox.open && (
        <div className="ema-lightbox" onClick={closeLightbox}>
          <div className="ema-lightbox-inner" onClick={(e) => e.stopPropagation()}>
            <button className="ema-lightbox-close" onClick={closeLightbox}>&times;</button>
            <button className="ema-lightbox-prev" onClick={prevPhoto}>&#8249;</button>
            <img src={PHOTOS[lightbox.index]} alt={`Photo ${lightbox.index + 1}`} />
            <button className="ema-lightbox-next" onClick={nextPhoto}>&#8250;</button>
            <div className="ema-lightbox-counter">{lightbox.index + 1} / {PHOTOS.length}</div>
          </div>
        </div>
      )}
    </main>
  );
}
